import {
  validateRequired,
  validateNonZeroInteger,
  validateDateRange,
  validateNotNull,
  validateSelectInteger,
  validateInteger,
  validateStartDate
} from "../../../../helpers/validationsForm";

const Inputs = (id) => {
  // Verifica si es un modo de edición
  const isEditing = id > 0;
  return [{
      id: String(1), // Convertido a string
      label: "Nombre De La Oferta",
      name: "aof_nombre",
      type: "text",
      placeholder: "Ingrese el nombre",
      validation: (value) => validateRequired(value),
      cssClass: (errors, name) => errors[name] ? 'is-invalid' : 'default-class',
    },
    {
      id: String(2), // ID del campo
      label: "Tipo De Precio", // Etiqueta visible en el formulario
      name: "aof_tipoprecio", // Nombre asociado al campo
      type: "select", // Tipo de input
      placeholder: "Seleccione el tipo de precio", // Texto de ayuda cuando el campo está vacío
      validation: (value) => {
        // Validación para el valor seleccionado
        if (value === 2) {
          return "El tipo de precio no puede ser COSTO."; // Mensaje de error específico
        }
    
        // Sin errores
        return null;
      },
      
    },
    
    {
      id: String(3), // Convertido a string
      label: "Tipo De Oferta",
      name: "aof_tipo",
      type: "select",
      placeholder: "Seleccione el tipo de oferta",
      options: [{
          value: 0,
          label: 'Por Fecha'
        },
        {
          value: 1,
          label: 'Por Fecha y Stock'
        },
      ],
      disable: isEditing, // Deshabilitar si estamos editando
      style: isEditing ? {
        backgroundColor: '#f0f0f0'
      } : {},
      validation: validateSelectInteger,
      cssClass: (errors, name) => errors[name] ? 'is-invalid' : 'default-class',
    },
    {
      id: String(4), // Convertido a string
      label: "Fecha De Inicio",
      name: "aof_oferta_desde",
      type: "date",
      placeholder: "Ingrese la fecha de inicio",
      disable: isEditing, // Deshabilitar si estamos editando
      style: isEditing ? {
        backgroundColor: '#f0f0f0'
      } : {},
      validation: validateStartDate,
      cssClass: (errors, name) => errors[name] ? 'is-invalid' : 'default-class',
    },
    {
      id: String(5), // Convertido a string
      label: "Fecha De Fin",
      name: "aof_oferta_hasta",
      type: "date",
      placeholder: "Ingrese la fecha de fin",
      validation: (value, form) => {
        const requiredError = validateRequired(value);
        if (requiredError) {
          return requiredError;
        }
        return validateDateRange(value, form, 'aof_oferta_desde', 'aof_oferta_hasta');
      },
      cssClass: (errors, name) => errors[name] ? 'is-invalid' : 'default-class',
     
    },
  ];
};

export default Inputs;